export function createPathModel({
                                  base,
                                  formPath = 'form',
                                  createIsBlank = false,
                                  editIsBlank = true
                                }) {
  return {
    create: {
      dev: `/${base}/${formPath}`,
      isBlank: createIsBlank
    },
    edit: {
      dev: `/${base}/${formPath}`,
      isBlank: editIsBlank
    }
  };
}